module.exports = __webpack_public_path__ + "media/stylesheets/images/SAReye-footer-transparent-539e7aabb5808311a1acee5a8082718d.png";